import { render, staticRenderFns } from "./UploadVideoTope.vue?vue&type=template&id=0c353367"
import script from "./UploadVideoTope.vue?vue&type=script&lang=js"
export * from "./UploadVideoTope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports